import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/resources/backyard-bird-bingo/page.js");
